import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import './App.css';
import '@fontsource/inter'; // Optional if not using system font fallback
import { StyleSheetManager } from 'styled-components';
import HomePage from './HomePage';
import DocumentationPage from './DocumentationPage';
import ImportsPage from './ImportsPage';
import SandboxPage from './SandboxPage';

function App() {
  return (
    <StyleSheetManager shouldForwardProp={(prop) => prop !== 'codeBlock'}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sandbox" element={<SandboxPage />} />
          <Route path="/documentation" element={<DocumentationPage />} />
          <Route path="/imports" element={<ImportsPage />} />
          {/* <Route path="/callback" element={<CallbackPage />} /> */}
        </Routes>
      </Router>
    </StyleSheetManager>
  );
}

export default App;
